import Vue from "vue"
import VueRouter from "vue-router"
import dashboard from "../views/dashboard.vue"
import login from "../views/login"
Vue.use(VueRouter)
const baseName = "盯单宝"
const routes = [
  {
    path: "/s/:enCode",
    name: "login",
    component: login,
    meta: { title: "登录" }
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "工作台"
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: dashboard
  }
]

const router = new VueRouter({
  //   mode: "history",
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title + "-" + baseName
  next()
})

export default router
